export const AUTH_WORKER_URL = {
    login: '/worker/login',
    register: '/worker/register',
    logout: '/worker/logout',
    me: '/worker/me',
    re_password: '/worker/re-password',
    activeAcount: '/worker/active-account',
    editProfile: '/worker/profile/edit',
    detailProfile: '/worker/profile/detail',
    changeEmail: '/worker/confirm/change-mail',
    forgetPassword: '/worker/forget-password',
    changePassword: '/worker/change-password',
    checkTokenTime: '/worker/check-token',
}

export const MUTATION_TYPE = {
    unsubscribeToken: 'UNSUBSCRIBE_TOKEN',
    updateWorkerInfo: 'UPDATE_USER_INFO',
    updateLoginStatus: 'UPDATE_LOGIN_STATUS',
    updateToken: 'UPDATE_TOKEN'
}
